import { get } from "lodash";

import { IHubContentType } from "../types/ihubContentType";

import { parseSharableLinkId } from "./api.utils";
import { QueryParam } from "./permission.utils";

export enum WindowProperty {
    IHUB_STATE = "INSIGHTS_HUB_APPLICATION_STATE",
    LOCATION = "location",
}

export const getWindowValue = (valuePath: string): string => {
    const result = get(window, valuePath);
    return result;
};

export const getInsightIdFromSearchParams = (): string | undefined => {
    const linkId = getValueFromSearchParams(QueryParam.IDENTIFIER);
    return linkId ? parseSharableLinkId(linkId).identifier : undefined;
};

export const getValueFromSearchParams = (param: string): string | undefined => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param) ?? undefined;
};

export const isMarketingContentFromSearchParams = (): boolean => {
    const linkId = getValueFromSearchParams(QueryParam.IDENTIFIER);
    if (!linkId) return false;

    try {
        const parsedInfo = parseSharableLinkId(linkId);
        return parsedInfo.contentType === IHubContentType.MARKETING_CONTENT;
    } catch (e) {
        return false;
    }
};

export const getBooleanFromString = (value: string | undefined): boolean => {
    if (value === null || value === "false") {
        return false;
    }
    if ((value && value === "true") || value === "") {
        return true;
    }
    return false;
};
